module.exports = __webpack_public_path__ + "static/img/app-store.af7bf2e9.svg";